// export const domain = "http://localhost:4008/api"
export const domain = "https://www.meslektas.com.tr/api"
